import { render, staticRenderFns } from "./p_company006.vue?vue&type=template&id=13edc916&scoped=true&"
import script from "./p_company006.vue?vue&type=script&lang=js&"
export * from "./p_company006.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13edc916",
  null
  
)

export default component.exports